// Domain and Route Configuration
export const DOMAIN_NAME = 'kpiTemplate';
export const TEMPLATE_ROUTE_ID = 34;

// API Endpoints
export const API_ENDPOINTS = {
    // Template endpoints
    GET_ALL_TEMPLATES: '/kpi/template/get/all',
    GET_TEMPLATE: '/kpi/template/get',
    GET_TEMPLATE_WITH_GOALS: '/kpi/template/get', // /:id/with-goals
    CREATE_TEMPLATE: '/kpi/template/create',
    UPDATE_TEMPLATE: '/kpi/template/update',
    DELETE_TEMPLATE: '/kpi/template/delete',
    
    // Goal management in template
    GET_TEMPLATE_GOALS: '/kpi/template', // /:id/goals
    ADD_GOAL_TO_TEMPLATE: '/kpi/template', // /:id/goals/add
    UPDATE_TEMPLATE_GOAL: '/kpi/template', // /:templateId/goals/:goalId
    REMOVE_GOAL_FROM_TEMPLATE: '/kpi/template', // /:templateId/goals/:goalId
    
    // Goals dropdown
    GET_ALL_GOALS: '/kpi/goal/get/all',
    
    // Departments
    GET_DEPARTMENTS: '/department/get/all'
};

// Table Column Configuration
export const TABLE_COLUMNS = [
    { id: 'name', label: 'Template Name', sortable: true, minWidth: 350, width: '11%' },
    { id: 'description', label: 'Description', sortable: false, minWidth: 300, width: '28%' },
    { id: 'goalsCount', label: 'Goals', sortable: false, minWidth: 140, align: 'center', width: '11%' },
    { id: 'updatedBy', label: 'Updated By', sortable: false, minWidth: 180, width: '17%' },
    { id: 'updatedAt', label: 'Updated At', sortable: true, minWidth: 180, width: '11%' },
    { id: 'actions', label: 'Actions', sortable: false, minWidth: 150, align: 'center', width: '11%' }
];

// Column Widths (based on ratio: name=1.4, description=2.5, goalsCount=1.1, updatedBy=1.7, updatedAt=1.1, actions=1.1)
export const COLUMN_WIDTHS = {
    name: '14%',
    description: '25%',
    goalsCount: '11%',
    updatedBy: '17%',
    updatedAt: '11%',
    actions: '11%'
};

// Goal Table Columns (for goals in template)
export const GOAL_TABLE_COLUMNS = [
    { id: 'goalName', label: 'Goal Name', minWidth: 250 },
    { id: 'category', label: 'Category', minWidth: 150 },
    { id: 'weight', label: 'Weight (%)', minWidth: 100, align: 'center' },
    { id: 'complexity', label: 'Complexity', minWidth: 120 },
    { id: 'actions', label: 'Actions', minWidth: 100, align: 'center' }
];

// Category Options
export const CATEGORY_OPTIONS = ['Main', 'Next Step', 'First Step', 'Advanced', 'Additional'];

// Pagination Configuration
export const ROWS_PER_PAGE_OPTIONS = [10, 20, 50, 100];
export const DEFAULT_PAGE_SIZE = 10;

// Error message extraction utility
export const getErrorMessage = (error, defaultMessage) => {
    // Prioritize API response message if it's a string
    if (error?.response?.data?.message && typeof error.response.data.message === 'string') {
        return error.response.data.message;
    }
    // Fall back to error message
    if (error?.message) {
        return error.message;
    }
    // Use default message
    return defaultMessage;
};
